import SEO from "../../components/SEO";
import HomeTestimonials from "../Home/HomeTestimonials/HomeTestimonials";
import AboutSec1 from "./AboutSec1/AboutSec1";
import AboutSec2 from "./AboutSec2/AboutSec2";
import AboutSec3 from "./AboutSec3/AboutSec3";

export default function About({ currentLanguage = "en" }) {
  // Translations for page title
  const pageTitles = {
    en: "About Us",
    fr: "À Propos de Nous",
  };

  // Get the title based on current language
  const pageTitle = pageTitles[currentLanguage] || pageTitles.en;

  return (
    <>
      <SEO title={pageTitle} />
      <AboutSec1 currentLanguage={currentLanguage} />
      <AboutSec2 currentLanguage={currentLanguage} />
      <AboutSec3 currentLanguage={currentLanguage} />
      <HomeTestimonials currentLanguage={currentLanguage} />
    </>
  );
}